import React from "react";
import { ShopTheLookProductTag } from "~/common/Store/models/Brand";

interface Props {
  index: number;
  tag: ShopTheLookProductTag;
  setActiveTagIndex: React.Dispatch<React.SetStateAction<number | null>>;
}

const ShopTheLookProductTagView = ({
  index,
  tag,
  setActiveTagIndex,
}: Props) => (
  <div
    key={`ShopTheLookTag${index}`}
    className="hotspot-tag"
    style={{ left: `${tag.xPosition}%`, top: `${tag.yPosition}%` }}
  >
    <button
      type="button"
      className="hotspot-tag__icon-wrap icon-tags"
      onClick={() => setActiveTagIndex(index)}
    >
      <span className="accessibility-text">Click to View Product Details</span>
    </button>
  </div>
);

export default ShopTheLookProductTagView;
